import {
	REQUEST_EDIT_UPDATE_ACCOUNT
} from "../types/settings/settings";

export const requestEditUpdateAccount = data => ({
	type: REQUEST_EDIT_UPDATE_ACCOUNT, data
});
